import Vue from 'vue'
import VueApexCharts from 'vue-apexcharts'
import VueAuth from '@websanova/vue-auth'
import ToggleButton from 'vue-js-toggle-button'
import Vuelidate from 'vuelidate'
import VueShortcuts from 'vue-shortcuts'
import Pusher from 'pusher-js'
import store from './store'
import './registerServiceWorker'
import './lang'
import './axios'
import './style'
import './progress'
import './filters'
import '@/utils/consoleLogs'
import router from './router'
import App from './App.vue'
import VueMask from 'v-mask'
import money from 'v-money'
// import App from './views/Admin/Admin.vue'

Vue.config.productionTip = false
window.Pusher = Pusher

Vue.use(VueMask)
Vue.use(ToggleButton)
Vue.use(VueApexCharts)
Vue.use(money, { precision: 4 })
Vue.component('apexchart', VueApexCharts)
Vue.use(VueShortcuts, { prevent: ['input', 'textarea'] })
Vue.use(Vuelidate)
Vue.use(VueAuth, {
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  rolesVar: 'view_permissions',
  parseUserData: user => user
})

export default new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
